// extracted by mini-css-extract-plugin
export default {"techstack":"techstack__WBlx-","techstackItem":"techstackItem__TJMQB"};